import type { Nullable } from "../../typescript"

export default function firstIfOnlyOne<T>(list: Nullable<Array<T>>): Nullable<T> {
  if (list?.length === 1) {
    return list[0]
  }
  return null
}